export default {"src":"/_next/static/media/icon_chat_header_light.78142c84.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};